const boardsAccessories = [
  {
    imageUrl: '/assets/images/Screenshot 2023-12-16 at 18.51.48 (1).png',
    label: 'Bande bitumeuse',
    showCheckbox: true,
  },
  {
    imageUrl: "/assets/images/Capture.png",
    label: 'Cale de ventilation',
    showCheckbox: true,
  },
  {
    imageUrl: '/assets/images/4381249 copy 2.png',
    label: "J'ai déjà mes accessoires",
    showCheckbox: true,
  },
]




const installationAccessories = [

  {
    imageUrl: '/assets/images/Bitmap(5).png',
    label: 'Espaceurs Novlek',
    showCheckbox: true,
  },
  {
    imageUrl: '/assets/images/Bitmap(3).png',
    label: 'Foret pour pré-perçage',
    showCheckbox: true,
  },
  {
    imageUrl: "/assets/images/Bitmap (4).png",
    label: 'Kit serre lames Novlek',
    showCheckbox: true,
  },
]

export {installationAccessories, boardsAccessories}  